import {
  USER_DETAILS,
  PORTFOLIO,
  SET_LANGUAGE,
  SET_PORTFOLIO_ITEM
} from 'config/actionTypes';
import initialState from './initialState';

const commonData = (state = initialState, action) => {
  switch (action.type) {
    case USER_DETAILS:
      return {
        ...state,
        userDetails: action.value
      };
    case PORTFOLIO:
      return {
        ...state,
        portfolio: action.value
      };
    case SET_LANGUAGE:
      return {
        ...state,
        currentLang: action.value
      };
    case SET_PORTFOLIO_ITEM:
      return {
        ...state,
        portfolioItem: action.value
      }

    default:
      return state;
  }
};
export default commonData;
